import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { useTimeZone } from '../../../../hooks'

import { getCalendarGridResponse } from './useCalendarGridItems.utils'

export function useCalendarGridItems({
  from,
  getItems,
  isEnabled,
  requestKey,
  to,
}) {
  const [items, setItems] = useState(EMPTY_LIST)
  const [dayLoads, setDayLoads] = useState(EMPTY_OBJECT)
  const [meta, setMeta] = useState(EMPTY_OBJECT)
  const [serverError, setServerError] = useState(null)

  const [isInitiated, setInitiated] = useState(false)
  const [isLoadingRange, setLoadingRange] = useState(true)
  const [reloadKey, setReloadKey] = useState(0)

  const readIdRef = useRef(0)

  const timezone = useTimeZone()

  async function readItems(readId) {
    setLoadingRange(true)

    return getItems({ from, timezone, to })
      .then(response => {
        if (readIdRef.current === readId) {
          const nextResponse = getCalendarGridResponse(response)

          setItems(nextResponse.items)
          setDayLoads(nextResponse.dayLoads)
          setMeta(nextResponse.meta)
          setServerError(null)
        }
      })
      .catch(error => {
        if (readIdRef.current === readId) {
          setServerError(error)
        }
      })
      .finally(() => {
        if (readIdRef.current === readId) {
          setLoadingRange(false)
          setInitiated(true)
        }
      })
  }

  useEffect(() => {
    readIdRef.current += 1

    if (isEnabled) {
      readItems(readIdRef.current)
    }
  }, [from, isEnabled, reloadKey, requestKey, timezone, to])

  function handleReload() {
    setReloadKey(prevKey => prevKey + 1)
  }

  return {
    dayLoads,
    handleReload,
    isLoading: !isInitiated,
    isRefetching: Boolean(isEnabled) && isLoadingRange && isInitiated,
    items,
    meta,
    serverError,
  }
}
